// Central source of truth for location (region + city) service pages.
const T = {
  closest: '1 to 3 business days',
  fast: '2 to 5 business days',
  standard: '4 to 7 business days',
  cross: '5 to 10 business days',
};

const BLURBS = [
  'We rebuild freeze dryers for {n} households, gardeners and small food producers.',
  'From {n} home users to busy commercial kitchens, we bring freeze dryers back to life.',
  '{n}-area owners ship us their freeze dryers and get them back running and warrantied.',
  'We keep {n} freeze dryers — home and business — running with quality rebuilds.',
];

export const slugify = (s) =>
  s.toLowerCase().replace(/[.'’]/g, '').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

// [regionSlug, regionName, country, tier, hubs, [cities...]]
const DATA = [
  // Canada
  ['alberta', 'Alberta', 'Canada', 'closest', 'Calgary, Edmonton, Red Deer and Lethbridge', ['Calgary', 'Edmonton', 'Red Deer', 'Lethbridge', 'Fort McMurray', 'Grande Prairie']],
  ['british-columbia', 'British Columbia', 'Canada', 'fast', 'Vancouver, Kelowna, Victoria and Kamloops', ['Vancouver', 'Kelowna', 'Victoria', 'Kamloops', 'Nanaimo', 'Prince George', 'Abbotsford']],
  ['saskatchewan', 'Saskatchewan', 'Canada', 'fast', 'Saskatoon, Regina and Prince Albert', ['Saskatoon', 'Regina', 'Prince Albert']],
  ['manitoba', 'Manitoba', 'Canada', 'fast', 'Winnipeg and Brandon', ['Winnipeg', 'Brandon']],
  ['ontario', 'Ontario', 'Canada', 'standard', 'Toronto, Ottawa, Hamilton and London', ['Toronto', 'Ottawa', 'Hamilton', 'London', 'Mississauga', 'Kitchener', 'Windsor', 'Barrie']],
  ['quebec', 'Quebec', 'Canada', 'standard', 'Montreal, Quebec City and Gatineau', ['Montreal', 'Quebec City', 'Gatineau', 'Laval', 'Sherbrooke']],
  ['nova-scotia', 'Nova Scotia', 'Canada', 'standard', 'Halifax and Sydney', ['Halifax', 'Sydney']],
  ['new-brunswick', 'New Brunswick', 'Canada', 'standard', 'Moncton, Fredericton and Saint John', ['Moncton', 'Fredericton', 'Saint John']],
  ['newfoundland-and-labrador', 'Newfoundland and Labrador', 'Canada', 'standard', "St. John's and area", ["St. John's"]],
  ['prince-edward-island', 'Prince Edward Island', 'Canada', 'standard', 'Charlottetown and area', ['Charlottetown']],
  // United States
  ['washington', 'Washington', 'USA', 'cross', 'Seattle, Spokane and Tacoma', ['Seattle', 'Spokane', 'Tacoma']],
  ['oregon', 'Oregon', 'USA', 'cross', 'Portland and Eugene', ['Portland', 'Eugene']],
  ['california', 'California', 'USA', 'cross', 'Los Angeles, San Diego and San Francisco', ['Los Angeles', 'San Diego', 'San Francisco', 'Sacramento', 'Fresno']],
  ['nevada', 'Nevada', 'USA', 'cross', 'Las Vegas and Reno', ['Las Vegas', 'Reno']],
  ['arizona', 'Arizona', 'USA', 'cross', 'Phoenix and Tucson', ['Phoenix', 'Tucson']],
  ['colorado', 'Colorado', 'USA', 'cross', 'Denver and Colorado Springs', ['Denver', 'Colorado Springs']],
  ['utah', 'Utah', 'USA', 'cross', 'Salt Lake City and Provo', ['Salt Lake City', 'Provo']],
  ['idaho', 'Idaho', 'USA', 'cross', 'Boise and area', ['Boise']],
  ['texas', 'Texas', 'USA', 'cross', 'Dallas, Houston, Austin and San Antonio', ['Dallas', 'Houston', 'Austin', 'San Antonio']],
  ['oklahoma', 'Oklahoma', 'USA', 'cross', 'Oklahoma City and Tulsa', ['Oklahoma City', 'Tulsa']],
  ['missouri', 'Missouri', 'USA', 'cross', 'Kansas City and St. Louis', ['Kansas City', 'St. Louis']],
  ['illinois', 'Illinois', 'USA', 'cross', 'Chicago and area', ['Chicago']],
  ['minnesota', 'Minnesota', 'USA', 'cross', 'Minneapolis and St. Paul', ['Minneapolis']],
  ['michigan', 'Michigan', 'USA', 'cross', 'Detroit and Grand Rapids', ['Detroit', 'Grand Rapids']],
  ['ohio', 'Ohio', 'USA', 'cross', 'Columbus and Cleveland', ['Columbus', 'Cleveland']],
  ['tennessee', 'Tennessee', 'USA', 'cross', 'Nashville and Memphis', ['Nashville', 'Memphis']],
  ['georgia', 'Georgia', 'USA', 'cross', 'Atlanta and area', ['Atlanta']],
  ['florida', 'Florida', 'USA', 'cross', 'Tampa, Orlando, Miami and Jacksonville', ['Tampa', 'Orlando', 'Miami', 'Jacksonville']],
  ['massachusetts', 'Massachusetts', 'USA', 'cross', 'Boston and area', ['Boston']],
  ['new-york', 'New York', 'USA', 'cross', 'New York City and Buffalo', ['New York', 'Buffalo']],
  ['pennsylvania', 'Pennsylvania', 'USA', 'cross', 'Philadelphia and Pittsburgh', ['Philadelphia', 'Pittsburgh']],
  ['north-carolina', 'North Carolina', 'USA', 'cross', 'Charlotte and Raleigh', ['Charlotte', 'Raleigh']],
];

export const REGIONS = {};
export const REGION_ORDER = [];
export const CITY_ORDER = [];
let bi = 0;
DATA.forEach(([slug, name, country, tier, hubs, cities]) => {
  REGIONS[slug] = { name, type: 'region', country, tier, transit: T[tier], hubs };
  REGION_ORDER.push(slug);
  (cities || []).forEach((cn) => {
    const cs = slugify(cn);
    if (REGIONS[cs]) return;
    REGIONS[cs] = {
      name: cn, type: 'city', country, province: slug, provinceName: name,
      tier, transit: T[tier], hubs: `${cn} and the surrounding area`,
      blurb: BLURBS[bi++ % BLURBS.length].replace(/\{n\}/g, cn),
    };
    CITY_ORDER.push(cs);
  });
});

export const ORDER = [...REGION_ORDER, ...CITY_ORDER];
export const ALL_SLUGS = ORDER.slice();
